module.exports = __webpack_public_path__ + "static/media/burrito_03_thumb_hover.ca72caaa.png";